var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllPubli(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#BED000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.595 13.2H15.495L13.365 10.395L11.475 12.9L10.095 11.205L8.595 13.2ZM6 18V6.9C6 6.66 6.09 6.45 6.27 6.27C6.45 6.09 6.66 6 6.9 6H17.1C17.34 6 17.55 6.09 17.73 6.27C17.91 6.45 18 6.66 18 6.9V14.7C18 14.94 17.91 15.15 17.73 15.33C17.55 15.51 17.34 15.6 17.1 15.6H8.4L6 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPubli);
export default __webpack_public_path__ + "static/media/allPubli.624796e786fd403fce51f08005c63482.svg";
export { ForwardRef as ReactComponent };